import styled from 'styled-components'

export const Wrapper = styled.section`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 3rem 1rem;
  background-color: #f4f4fc;
`

export const Header = styled.div`
  margin-bottom: 2rem;
  padding-top: 90px;

  span {
    font-weight: 600;
    color: #1d1d5c;
    font-size: 1rem;
  }

  h2 {
    font-size: 4rem;
    font-weight: 800;
    margin: 0.5rem 0;
    padding-block: 1rem;
    color: #1d1d5c;

    strong {
      color: #f89b29;
    }
  }

  @media screen and (max-width: 1190px) {
    margin-bottom: 0;
    h2 {
      font-size: 3rem;
    }
  }
  @media screen and (max-width: 800px) {
    margin-bottom: 0;
    h2 {
      font-size: 2rem;
    }
  }
  @media screen and (max-width: 450px) {
    h2 {
      font-size: 1.2rem;
      margin-bottom: 0;
      padding-block: 0;
    }
  }
`
export const TitleSection = styled.p`
  color: #0c0c59;
  font-weight: 700;
  font-size: 1.5rem;
  margin-top: 0;
  margin-bottom: 0px;

  &::before,
  &::after {
    content: '-';
    margin: 0 1rem;
    color: #0c0c59;
  }

  @media screen and (max-width: 1190px) {
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  @media screen and (max-width: 800px) {
    font-size: 1rem;
    margin-bottom: 10px;
  }
  @media screen and (max-width: 450px) {
    font-size: 14px;
  }
`

export const LogosContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
  @media screen and (max-width: 1190px) {
    flex-wrap: wrap;
    margin-top: 0;
  }
  @media (max-width: 650px) {
    justify-content: center;
  }
`

export const LogoCard = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 50%;
  padding-inline: 4rem;
  padding-block: 2rem;
  overflow: hidden;

  img:hover {
    width: 200px;
    height: 200px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 15px;
    left: 75px;
    width: 60px;
    height: 60px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.5), transparent 70%);
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
    z-index: 2;
  }

  &:hover::before {
    opacity: 1;
  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div:hover {
    width: 180px;
    height: 180px;
    overflow: hidden;
    -webkit-border-radius: 50%;
    box-shadow: -10px -10px 20px rgba(255, 255, 255, 0.6), 8px 8px 20px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -10px -10px 20px rgba(255, 255, 255, 0.6), 8px 8px 20px rgba(0, 0, 0, 0.3);
    background-color: transparent;
  }

  @media screen and (max-width: 1190px) {
    img {
      width: 150px;
      height: 150px;
    }

    div {
      width: 180px;
      height: 180px;
    }

    img:hover {
      width: 180px;
      height: 180px;
    }

    div:hover {
      width: 160px;
      height: 160px;
    }
  }

  @media (max-width: 800px) {
    img {
      width: 90px;
      height: 90px;
    }

    div {
      width: 120px;
      height: 120px;
    }
    img:hover {
      width: 92px;
      height: 92px;
    }

    div:hover {
      width: 90px;
      height: 90px;
    }
  }
  @media (max-width: 500px) {
    img {
      width: 70px;
      height: 70px;
    }

    div {
      width: 100px;
      height: 100px;
    }
    img:hover {
      width: 70px;
      height: 70px;
    }

    div:hover {
      width: 68px;
      height: 68px;
    }

    padding-inline: 20px !important;
  }
`

export const LogoText = styled.p`
  font-weight: 600;
  color: #0a0a3f;
  font-size: 1.6rem;
  margin-top: 2rem;
  text-align: center;
  @media (max-width: 800px) {
    font-size: 1rem;
    margin-top: 0;
  }
  @media (max-width: 500px) {
    font-size: 14px;
    margin-top: 0;
    width: 100px;
  }
`
